<script setup lang="ts">
</script>

<template>
  <Page />
</template>
